import axios from "axios";
import store from "../store";
import { apiBasePath } from "../config";
import { actionTypes } from "../store-types";
import { serverState, ServerDownError, isServerDownFailure, markServerDown } from "../utils/serverHealth";

axios.defaults.baseURL = apiBasePath;
// احراز هویت اکنون با کوکی HttpOnly است؛ همه‌ی درخواست‌ها باید کوکی را همراه ببرند.
axios.defaults.withCredentials = true;

axios.interceptors.request.use((config) => {
    config.withCredentials = true;
    // سرور قطع است → درخواست را اصلاً نفرست؛ serverHealth خودش با backoff سرور را می‌سنجد.
    if (serverState.down) return Promise.reject(new ServerDownError());
    return config;
});

// --- Response: تشخیص قطعی سرور + مدیریت انقضای نشست ---
let handlingUnauthorized = false;
axios.interceptors.response.use(
    (response) => response,
    (error) => {
        if (isServerDownFailure(error)) markServerDown();

        const status = error && error.response && error.response.status;
        const url = (error && error.config && error.config.url) || "";
        const isAuthCall = /account\/(login|register|forgotpassword|confirm|resendCode|session|IsAuthenticated)/i.test(url);
        // ثبت خطا نباید باعث logout/redirect شود
        const isLogCall = /(^|\/)LogEvent(\/|$)/i.test(url);

        if (status === 401 && !isAuthCall && !isLogCall && !handlingUnauthorized) {
            handlingUnauthorized = true;
            try {
                store.dispatch(actionTypes.CLEAR_LOGIN);
            } catch (e) {
                /* noop */
            }
            const path = typeof location !== "undefined" ? location.pathname : "";
            if (!/^\/account\//.test(path)) {
                location.assign("/account/login");
            }
        }
        return Promise.reject(error);
    }
);

export default {
    basePath: apiBasePath,
};
